export const ACCENT_COLOR_LIGHT_PROP = "--color-accent-light";
export const ACCENT_COLOR_DARK_PROP = "--color-accent-dark";
export const ACCENT_COLOR_VAR = "var(--color-accent)";
